/**
 * The main api service
 */
import http from '@util/http';
import { hr } from '../req';

export async function queryHrList(params) {
  return http.get(hr.HR_LIST, params);
}

export async function queryHrInfo(params) {
  return http.get(hr.HR_INFO, params);
}

export async function queryRegisterHr(params) {
  return http.post(hr.HR_REGISTER, params);
}

export async function querySaveHr(params) {
  return http.post(hr.HR_SAVE, params);
}

export async function queryDisableHr(params) {
  return http.get(hr.HR_DISABLE, params);
}

export async function queryDeleteHr(params) {
  return http.get(hr.HR_DELETE, params);
}

export async function queryEnableHr(params) {
  return http.get(hr.HR_ENABLE, params);
}

export async function queryResetHr(params) {
  return http.get(hr.HR_RESET_PWD, params);
}

export async function queryExportHr(params) {
  http.download(hr.HR_EXPORT, params, '用户资料导出.xlsx');
}

export async function queryImportHr(params) {
  return http.post(hr.HR_IMPORT, params);
}

export async function queryDownloadHrTemplate() {
  http.download(hr.DOWNLOAD_HR_TEMPLATE, {}, '员工导入模板.xlsx');
}



// WEBPACK FOOTER //
// ./src/api/hr/hr.js